import { render, staticRenderFns } from "./trivia.vue?vue&type=template&id=5e1a3d12&scoped=true&"
import script from "./trivia.vue?vue&type=script&lang=js&"
export * from "./trivia.vue?vue&type=script&lang=js&"
import style0 from "./trivia.vue?vue&type=style&index=0&id=5e1a3d12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1a3d12",
  null
  
)

export default component.exports